import { Actions } from '../../interfaces'
import { Concessionaire } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Concessionaire },
  actions: { [Concessionaire.name]: actions },
}
